import { ThemeInterface } from './theme-interface';
import { defaultTheme } from './default-theme';
import { getThemeIconsLight, ThemeMap } from './theme-map';

const raaTheme: ThemeInterface = {
  name: ThemeMap.RAA,
  type: defaultTheme.type,
  styles: {
    global: [{ themeVariable: '--ion-item-background', value: 'white' }],
    brandPrimary: [
      { themeVariable: '--ion-color-brand-primary', value: '#000000' },
      { themeVariable: '--ion-color-brand-primary-rgb', value: '0, 0, 0' },
      { themeVariable: '--ion-color-brand-primary-contrast', value: '#ffffff' },
      { themeVariable: '--ion-color-brand-primary-contrast-rgb', value: '255, 255, 255' },
      { themeVariable: '--ion-color-brand-primary-shade', value: '#000000' },
      { themeVariable: '--ion-color-brand-primary-tint', value: '#1a1a1a' },
    ],
    textPrimary: defaultTheme.styles.textPrimary,
    textTertiary: defaultTheme.styles.textTertiary,
    textSecondary: defaultTheme.styles.textSecondary,
    backgroundPrimary: [
      { themeVariable: '--ion-color-background-primary', value: '#E8E2D3' },
      { themeVariable: '--ion-color-background-primary-rgb', value: '232, 226, 211' },
      { themeVariable: '--ion-color-background-primary-contrast', value: '#000000' },
      { themeVariable: '--ion-color-background-primary-contrast-rgb', value: '0, 0, 0' },
      { themeVariable: '--ion-color-background-primary-shade', value: '#ccc7ba' },
      { themeVariable: '--ion-color-background-primary-tint', value: '#eae5d7' },
    ],
    backgroundSecondary: [
      { themeVariable: '--ion-color-background-secondary', value: '#FFE600' },
      { themeVariable: '--ion-color-background-secondary-rgb', value: '255, 230, 0' },
      { themeVariable: '--ion-color-background-secondary-contrast', value: '#000000' },
      { themeVariable: '--ion-color-background-secondary-contrast-rgb', value: '0, 0, 0' },
      { themeVariable: '--ion-color-background-secondary-shade', value: '#e0ca00' },
      { themeVariable: '--ion-color-background-secondary-tint', value: '#ffe91a' },
    ],
    backgroundTertiary: [
      { themeVariable: '--ion-color-background-tertiary', value: '#000000' },
      { themeVariable: '--ion-color-background-tertiary-rgb', value: '0, 0, 0' },
      { themeVariable: '--ion-color-background-tertiary-contrast', value: '#ffffff' },
      { themeVariable: '--ion-color-background-tertiary-contrast-rgb', value: '255, 255, 255' },
      { themeVariable: '--ion-color-background-tertiary-shade', value: '#000000' },
      { themeVariable: '--ion-color-background-tertiary-tint', value: '#1a1a1a' },
    ],
    subTabLabels: [
      { themeVariable: '--ion-color-sub-tab-labels', value: '#3A245E' },
      { themeVariable: '--ion-color-sub-tab-labels-rgb', value: '58,36,94' },
      // at the moment using the contrast value for the tab labels
      { themeVariable: '--ion-color-sub-tab-labels-contrast', value: '#444444' },
      { themeVariable: '--ion-color-sub-tab-labels-contrast-rgb', value: '68, 68, 68' },
      { themeVariable: '--ion-color-sub-tab-labels-shade', value: '#332053' },
      { themeVariable: '--ion-color-sub-tab-labels-tint', value: '#4e3a6e' },
    ],
    solar: defaultTheme.styles.solar,
    consumption: defaultTheme.styles.consumption,
    battery: defaultTheme.styles.battery,
    consumed: defaultTheme.styles.consumed,
  },
  headerLogo: {
    path: getThemeIconsLight[ThemeMap.RAA],
    style: {
      height: '30px',
    },
  },
  footerLogo: defaultTheme.footerLogo,
  footerColoredLogo: defaultTheme.footerColoredLogo,
  iconsSvgPath: defaultTheme.iconsSvgPath,
  chartColors: {
    primary: { value: '#FFE600', opacValue: 'rgba(255, 230, 0, 0.4)' },
    light: { value: '#000000', opacValue: 'rgba(0, 0, 0, 0.4)' },
    secondary: { value: '#4696EC', opacValue: 'rgba(70, 150, 236, 0.4)' },
    tertiary: { value: '#008A32', opacValue: 'rgba(0, 178, 153, 0.4)' },

    colorFive: { value: '#7BA24B', opacValue: 'rgba(123, 162, 75, 0.4)' },
    colorSix: { value: '#3933DE', opacValue: 'rgba(57, 51, 222, 0.4)' },
    colorSeven: { value: '#AE33DE', opacValue: 'rgba(174, 51, 222, 0.4)' },
    colorEight: { value: '#6B9FAF', opacValue: 'rgba(107, 159, 175, 0.4)' },
    colorNine: { value: '#DE3355', opacValue: 'rgba(222, 51, 85, 0.4)' },
    colorTen: { value: '#96F70D', opacValue: 'rgba(150, 247, 13, 0.4)' },
  },
  vppChartColors: defaultTheme.vppChartColors,
  streamChartColor: '#FFE600',
  buttons: {
    primary: [
      { themeVariable: '--ion-color-button-primary', value: '#000000' },
      { themeVariable: '--ion-color-button-primary-rgb', value: '0, 0, 0' },
      { themeVariable: '--ion-color-button-primary-contrast', value: '#ffffff' },
      { themeVariable: '--ion-color-button-primary-contrast-rgb', value: '255, 255, 255' },
      { themeVariable: '--ion-color-button-primary-shade', value: '#000000' },
      { themeVariable: '--ion-color-button-primary-tint', value: '#1a1a1a' },
    ],
    secondary: [
      { themeVariable: '--ion-color-button-secondary', value: '#FFE600' },
      { themeVariable: '--ion-color-button-secondary-rgb', value: '255, 230, 0' },
      { themeVariable: '--ion-color-button-secondary-contrast', value: '#000000' },
      { themeVariable: '--ion-color-button-secondary-contrast-rgb', value: '0, 0, 0' },
      { themeVariable: '--ion-color-button-secondary-shade', value: '#e0ca00' },
      { themeVariable: '--ion-color-button-secondary-tint', value: '#ffe91a' },
    ],
    success: [
      { themeVariable: '--ion-color-success', value: '#65B9AF' },
      { themeVariable: '--ion-color-success-rgb', value: '101, 185, 175' },
      { themeVariable: '--ion-color-success-contrast', value: '#000000' },
      { themeVariable: '--ion-color-success-contrast-rgb', value: '0, 0, 0' },
      { themeVariable: '--ion-color-success-shade', value: '#59a39a' },
      { themeVariable: '--ion-color-success-tint', value: '#74c0b7' },
    ],
    warning: [
      { themeVariable: '--ion-color-warning', value: '#F4B44E' },
      { themeVariable: '--ion-color-warning-rgb', value: '244, 180, 78' },
      { themeVariable: '--ion-color-warning-contrast', value: '#000000' },
      { themeVariable: '--ion-color-warning-contrast-rgb', value: '0, 0, 0' },
      { themeVariable: '--ion-color-warning-shade', value: '#d79e45' },
      { themeVariable: '--ion-color-warning-tint', value: '#f5bc60' },
    ],
    danger: [
      { themeVariable: '--ion-color-danger', value: '#E60D21' },
      { themeVariable: '--ion-color-danger-rgb', value: '230, 13, 33' },
      { themeVariable: '--ion-color-danger-contrast', value: '#ffffff' },
      { themeVariable: '--ion-color-danger-contrast-rgb', value: '255, 255, 255' },
      { themeVariable: '--ion-color-danger-shade', value: '#ca0b1d' },
      { themeVariable: '--ion-color-danger-tint', value: '#e92537' },
    ],
    successLite: [
      { themeVariable: '--ion-color-success-lite', value: '#B5EECC' },
      { themeVariable: '--ion-color-success-lite-rgb', value: '181, 238, 204' },
      { themeVariable: '--ion-color-success-lite-contrast', value: '#000000' },
      { themeVariable: '--ion-color-success-lite-contrast-rgb', value: '0, 0, 0' },
      { themeVariable: '--ion-color-success-lite-shade', value: '#9fd1b4' },
      { themeVariable: '--ion-color-success-lite-tint', value: '#bcf0d1' },
    ],
    warningLite: [
      { themeVariable: '--ion-color-warning-lite', value: '#FEEACB' },
      { themeVariable: '--ion-color-warning-lite-rgb', value: '254, 234, 203' },
      { themeVariable: '--ion-color-warning-lite-contrast', value: '#000000' },
      { themeVariable: '--ion-color-warning-lite-contrast-rgb', value: '0, 0, 0' },
      { themeVariable: '--ion-color-warning-lite-shade', value: '#e0ceb3' },
      { themeVariable: '--ion-color-warning-lite-tint', value: '#feecd0' },
    ],
    dangerLite: [
      { themeVariable: '--ion-color-danger-lite', value: '#FCD1D5' },
      { themeVariable: '--ion-color-danger-lite-rgb', value: '252, 209, 213' },
      { themeVariable: '--ion-color-danger-lite-contrast', value: '#000000' },
      { themeVariable: '--ion-color-danger-lite-contrast-rgb', value: '0, 0, 0' },
      { themeVariable: '--ion-color-danger-lite-shade', value: '#deb8bb' },
      { themeVariable: '--ion-color-danger-lite-tint', value: '#fcd6d9' },
    ],
  },
  svgIcons: {
    primarySvg: [
      { themeVariable: '--ion-color-primary-svg', value: '#FFE600' },
      { themeVariable: '--ion-color-primary-svg-rgb', value: '255, 230, 0' },
      { themeVariable: '--ion-color-primary-svg-contrast', value: '#000000' },
      { themeVariable: '--ion-color-primary-svg-contrast-rgb', value: '0, 0, 0' },
      { themeVariable: '--ion-color-primary-svg-shade', value: '#e0ca00' },
      { themeVariable: '--ion-color-primary-svg-tint', value: '#ffe91a' },
    ],
  },
  tablesRow: {
    primaryTile: [
      { themeVariable: '--ion-color-table-primary-tile', value: '#F9F7F4' },
      { themeVariable: '--ion-color-table-primary-tile-rgb', value: '249, 247, 244' },
      { themeVariable: '--ion-color-table-primary-tile-contrast', value: '#000000' },
      { themeVariable: '--ion-color-table-primary-tile-contrast-rgb', value: '0, 0, 0' },
      { themeVariable: '--ion-color-table-primary-tile-shade', value: '#dbd9d7' },
      { themeVariable: '--ion-color-table-primary-tile-tint', value: '#faf8f5' },
    ],
    secondaryTile: [
      { themeVariable: '--ion-color-table-secondary-tile', value: '#E8E2D3' },
      { themeVariable: '--ion-color-table-secondary-tile-rgb', value: '232, 226, 211' },
      { themeVariable: '--ion-color-table-secondary-tile-contrast', value: '#000000' },
      { themeVariable: '--ion-color-table-secondary-tile-contrast-rgb', value: '0, 0, 0' },
      { themeVariable: '--ion-color-table-secondary-tile-shade', value: '#ccc7ba' },
      { themeVariable: '--ion-color-table-secondary-tile-tint', value: '#eae5d7' },
    ],
    grayTile: [
      { themeVariable: '--ion-color-table-gray-tile', value: '#F9F7F4' },
      { themeVariable: '--ion-color-table-gray-tile-rgb', value: '249, 247, 244' },
      { themeVariable: '--ion-color-table-gray-tile-contrast', value: '#000000' },
      { themeVariable: '--ion-color-table-gray-tile-contrast-rgb', value: '0, 0, 0' },
      { themeVariable: '--ion-color-table-gray-tile-shade', value: '#dbd9d7' },
      { themeVariable: '--ion-color-table-gray-tile-tint', value: '#faf8f5' },
    ],
  },
};

export { raaTheme };
